import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Briefcase, Users, FileText, Mail, Award, DollarSign, HelpCircle } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CursorGlow from '../components/CursorGlow';

const Sitemap = () => {
  const sections = [
    {
      title: 'Ana Sayfalar',
      icon: Home,
      links: [
        { name: 'Ana Sayfa', path: '/' },
        { name: 'Hakkımızda', path: '/hakkimizda' },
        { name: 'Ekibimiz', path: '/ekip' },
        { name: 'İletişim', path: '/iletisim' },
        { name: 'Kariyer', path: '/kariyer' }
      ]
    },
    {
      title: 'Hizmetler',
      icon: Briefcase,
      links: [
        { name: 'Tüm Hizmetler', path: '/hizmetler' },
        { name: 'Mobil Uygulama Geliştirme', path: '/services/mobile-app-development' },
        { name: 'Yapay Zeka Entegrasyonu', path: '/services/ai-integration' },
        { name: 'Web & Arayüz Tasarımı', path: '/services/web-design' },
        { name: 'SEO & Dijital Büyüme', path: '/services/digital-growth' },
        { name: 'Sosyal Medya Yönetimi', path: '/services/social-media' },
        { name: 'E-Ticaret Sistemleri', path: '/services/ecommerce' }
      ]
    },
    {
      title: 'Çalışmalarımız',
      icon: Award,
      links: [
        { name: 'Portfolio', path: '/calismaalarimiz' },
        { name: 'Sosyal Medya Case Study', path: '/portfolyo/sosyal-medya' },
        { name: 'SEO Case Study', path: '/portfolyo/seo' },
        { name: 'Web Uygulaması Case Study', path: '/portfolyo/web' },
        { name: 'Mobil Uygulama Case Study', path: '/portfolyo/mobil-uygulama' },
        { name: 'Referanslar', path: '/referanslar' }
      ]
    },
    {
      title: 'Blog & İçerik',
      icon: FileText,
      links: [
        { name: 'Blog Ana Sayfa', path: '/blog' },
        { name: 'Teknoloji', path: '/blog?category=teknoloji' },
        { name: 'Dijital Pazarlama', path: '/blog?category=pazarlama' },
        { name: 'Tasarım', path: '/blog?category=tasarim' }
      ]
    },
    {
      title: 'Fiyatlandırma & Teklif',
      icon: DollarSign,
      links: [
        { name: 'Fiyatlandırma', path: '/fiyatlandirma' },
        { name: 'Ücretsiz Web Analizi', path: '/web-analiz' }
      ]
    },
    {
      title: 'Yasal & Destek',
      icon: HelpCircle,
      links: [
        { name: 'Gizlilik Politikası', path: '/sozlesmeler' },
        { name: 'Kullanım Koşulları', path: '/sozlesmeler' },
        { name: 'KVKK', path: '/sozlesmeler' },
        { name: 'Çerez Politikası', path: '/sozlesmeler' }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-slate-900">
      <CursorGlow />
      <Header />

      <section className="relative pt-32 pb-20">
        <div className="absolute inset-0">
          <div className="absolute w-[600px] h-[600px] bg-cyan-500/20 rounded-full blur-3xl top-0 right-1/4 animate-pulse"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Site
              <span className="bg-gradient-to-r from-cyan-400 to-teal-400 bg-clip-text text-transparent"> Haritası</span>
            </h1>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
              Tüm sayfalarımıza hızlıca ulaşın
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {sections.map((section, index) => (
              <div
                key={index}
                className="bg-slate-800/40 backdrop-blur-sm border border-slate-700/50 rounded-2xl p-6 hover:border-cyan-500/50 transition-all"
              >
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-lg flex items-center justify-center">
                    <section.icon className="w-5 h-5 text-white" />
                  </div>
                  <h2 className="text-xl font-bold text-white">{section.title}</h2>
                </div>

                <ul className="space-y-3">
                  {section.links.map((link, idx) => (
                    <li key={idx}>
                      <Link
                        to={link.path}
                        className="text-gray-400 hover:text-cyan-400 transition-colors flex items-center group"
                      >
                        <span className="w-0 h-0.5 bg-cyan-400 group-hover:w-2 transition-all duration-300 mr-0 group-hover:mr-2"></span>
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Sitemap;
